export default "__VITE_ASSET__GQQ7qP7k__"